var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"kd-region-picker"},[_c('kd-picker',{attrs:{"options":_vm.options,"value":_vm.valueArray,"visible":_vm.pickerVisible},on:{"input":_vm.confirm,"update:visible":function($event){_vm.pickerVisible=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }